import { DatabaseChangeType } from '@databases/types/redux';

import { getNewIndexWithHiddenFields } from '../../../../database/view/view';
import { YJSChangeHandler } from '../../types';

export const reorderField: YJSChangeHandler<DatabaseChangeType.REORDER_FIELD> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    const newIndex = getNewIndexWithHiddenFields(
      change.newIndex,
      db.fields,
      change.hiddenFields
    );

    db.reorderField(change.fieldId, newIndex);
  });
};
